<template>
    <div ref="form">
        <div v-if="loadingUser">
            <div class="vx-card__title mb-4">
                <h4 class="mb-4">Looking Up Your Account</h4>
                <p>Please wait while we look up your account...</p>
            </div>
        </div>
        <div v-else-if="lookupResult">
            <div class="vx-card__title mb-4">
                <h4 class="mb-4">Activate Account</h4>
                <p>
                    This account has been created for <a :href="localEmail">{{ localEmail }}</a
                    >. Please enter and confirm your password to activate.
                </p>
            </div>
            <vs-input
                type="password"
                name="password"
                icon-no-border
                icon="icon-lock"
                icon-pack="feather"
                placeholder="Password"
                v-model="password"
                class="w-full inline-validation mt-2"
                v-validate="'required|password'"
                val-icon-success="icon-check"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                :success="!!password && !errors.has('password')"
                :danger="errors.has('password')"
                :danger-text="errors.first('password')"
            />

            <vs-input
                type="password"
                name="password confirmation"
                icon-no-border
                icon="icon-lock"
                icon-pack="feather"
                placeholder="Confirm Password"
                v-model="passwordConfirm"
                class="w-full inline-validation mt-2"
                v-validate="{ required: true, is: password, regex: '', regex: '' }"
                val-icon-success="icon-check"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                @keyup.enter="submit"
                :success="!!passwordConfirm && !errors.has('password confirmation')"
                :danger="errors.has('password confirmation')"
                :danger-text="errors.first('password confirmation')"
            />
            <vx-button :disabled="!validated || success" class="float-right mt-2" @click="submit"
                >Activate</vx-button
            >
        </div>
        <div v-else-if="invalidToken">
            <div class="vx-card__title mb-4">
                <h4 class="mb-4">Invalid Link</h4>
                <p>This link is no longer valid.</p>
            </div>
            <vx-button class="float-right mt-4" @click="goToLogin">Return to Login</vx-button>
        </div>
        <div v-else>
            <div class="vx-card__title mb-4">
                <h4 class="mb-4">Error</h4>
                <p>
                    Something went wrong while trying to lookup your account. Please check your
                    internet and try again.
                </p>
            </div>
            <vx-button class="float-right mt-4" @click="lookup">Retry</vx-button>
        </div>
    </div>
</template>

<script>
import { mapQueries } from '../../../plugins/mappers'

export default {
    name: 'activate',
    props: {
        email: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            password: '',
            passwordConfirm: '',
            invalidToken: false,
            loadingUser: true,
            submitting: false,
            lookupResult: null,
            success: false
        }
    },
    computed: {
        ...mapQueries('token'),
        localEmail: {
            get() {
                return this.email
            },
            set(val) {
                this.$emit('update:email', val)
            }
        },
        validated() {
            return !this.errors.any() && this.password !== '' && this.passwordConfirm !== ''
        }
    },
    methods: {
        async lookup() {
            if (!this.lookupResult) {
                this.startLoad(this.$refs.form)
                try {
                    this.lookupResult = await this.$api.auth.lookup(this.token)
                    this.localEmail = this.lookupResult.email
                } catch (error) {
                    this.notifyServerError(error)
                    if (error.response.status == 404 || error.response.status == 401) {
                        this.invalidToken = true
                    }
                } finally {
                    this.loadingUser = false
                    this.endLoad(this.$refs.form)
                }
            }
        },
        async submit() {
            if (await this.$validator.validate()) {
                try {
                    this.startLoad(this.$refs.form)
                    this.submitting = true
                    var minDelay = this.delayFor(1000)
                    var response = await this.$api.auth.reset_password(this.token, this.password)

                    await minDelay
                    this.notifySuccess('Account Activated', `Please try and login.`, 5000)
                    this.success = true
                    this.endLoad(this.$refs.form)
                    await this.delayFor(1000)
                    this.goToLogin()
                } catch (error) {
                    this.notifyServerError(error)
                    this.submitting = false
                    this.endLoad(this.$refs.form)
                }
            }
        },
        goToLogin() {
            this.$router.push('/account/login')
        }
    },
    async mounted() {
        const dict = {
            custom: {
                'password confirmation': {
                    is: 'Your passwords do not match'
                }
            }
        }
        this.$validator.localize('en', dict)

        if (!this.token) {
            this.$router.push({ name: '404' })
        }
        await this.lookup()
    }
}
</script>
